<template>
  <l-cache :get-data="getPermission" :id="$route.query.id" ref="cache">
    <permission-form slot-scope="{data}" :permission="data"></permission-form>
  </l-cache>
</template>

<script>
import PermissionForm from './permissionForm'
export default {
  name: 'EditPermission',
  components: {PermissionForm},
  methods: {
    async getPermission () {
      let {items} = await this.$store.dispatch('userAdmin/getPermissions', {
        pagination: {},
        filter: [{key: 'id', value: this.$route.query.id}]
      })
      if (items && items.length > 0) {
        let p = items[0]
        return p
      }
      else {
        throw Error('未找到该权限')
      }
    },
  }
}
</script>

<style scoped>

</style>
